import { request } from '@umijs/max';
import { Edge, Node } from '../types';
import { NodesJobData } from './type';

export { getTags as getExtractionTags } from '@/services/custom/extractConfig';

interface GetFullWorkflow {
  nodes: Node[];
  edges: Edge[];
}

/** 全量获取画布 */
export const getFullWorkflow = async (template_code: string) => {
  const res = await request<IRes<GetFullWorkflow>>(
    `/supertext-java/extraction/template/canvas/${template_code}`,
    {
      method: 'GET',
    },
  );

  return {
    nodes: res.data.nodes,
    edges: res.data.edges,
  };
};

getFullWorkflow.queryKey = {
  method: 'GET',
  url: '/supertext-java/extraction/template/canvas/template_code',
};

/**
 * 保存画布内容
 * https://app.apifox.com/link/project/2651026/apis/api-211422860
 */
export const syncWorkflowDraft = async (data: {
  template_code: string;
  nodes: Node[];
  edges: Edge[];
}) => {
  return request<IRes<{ nodes: any; edges: any }>>(
    '/supertext-java/extraction/template/canvas',
    {
      method: 'POST',
      data,
    },
  );
};

/**
 * @description 保存节点表单 (job_data / form)
 * https://app.apifox.com/link/project/2651026/apis/api-211774144
 */
export const saveNodeJobData = ({
  template_code,
  node_uid,
  body,
}: {
  template_code: string;
  node_uid: string;
  body: Node['data']['_form'];
}) => {
  return request<
    IRes<{
      valid: boolean;
      canvas_node_tags: {
        tag_name: string;
        table_name?: string;
        tag_type: 1 | 2;
      }[];
    }>
  >(`/supertext-java/extraction/template/${template_code}/node/${node_uid}`, {
    method: 'POST',
    data: {
      job_data: body,
    },
  });
};

/** 查询抽取自定义节点 */
export const getExtractionCustomNode = async ({
  template_code,
  node_id,
}: {
  template_code: string;
  node_id: string;
}) => {
  //mock
  // await sleep(1000);
  // return {
  //   success: true,
  //   data: {
  //     node_uid,
  //     template_code,
  //     jobData: {
  //       type: 'semantic_rules_extraction',
  //       title: '语义规则抽取',
  //     },
  //     // body: {
  //     // type: 'semantic_rules_extraction',
  //     // },
  //   },
  // };

  const res = await request<
    IRes<{
      job_data: NodesJobData;
      valid: boolean;
      name: string;
      id: string;
    }>
  >(`/supertext-java/extraction/template/${template_code}/node/${node_id}`, {
    method: 'GET',
  });
  return res.data;
};

getExtractionCustomNode.queryKey = {
  method: 'GET',
  url: '/supertext-java/extraction/template/{template_code}/node/{node_id}',
};

// export const getExtractionTags = async ({
//   template_code,
// }: {
//   template_code: string;
// }) => {
//   const res = await request<
//     IRes<{
//       text_tags: {
//         tag_name: string;
//         tag_code: string;
//       }[];
//       table_tags: {
//         table_name: string;
//         table_code: string;
//         tags: {
//           tag_code: string;
//           tag_name: string;
//         }[];
//       }[];
//     }>
//   >(`/supertext-java/extraction/template/tags/${template_code}`, {
//     method: 'GET',
//   });
//
//   return res.data;
// };

// getExtractionTags.queryKey = {
//   method: 'GET',
//   url: '/supertext-java/extraction/template/tags/{template_code}',
// };
